<mat-card class="mat-elevation-z0">
    <mat-card-title class="header">
        <h2 appLocalizationPopupDirective localizationCode="LeaveHistory">
            {{ 'LeaveHistory' | translate: {Default: "Leave History"} }}
        </h2>
    </mat-card-title>
    <mat-card-content>
        <div class="top-container">
            <ng-container *ngIf="isLoadingPermissions; else loaded">
                <ngx-skeleton-loader
                    count="5"
                    [theme]="{ 
                        'height.px': 50
                    }"
                ></ngx-skeleton-loader>
                </ng-container>
                <ng-template #loaded>
                    <div class="coverage-container" *ngIf="timeOffLeaveTypes$ | withLoading | async as timeOffLeaveTypes">
                        <ng-template [ngIf]="timeOffLeaveTypes.value">
                            <button appLocalizationPopupDirective localizationCode="AddAPolicy" mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="openAssignPolicyDialog()" *appTableAccess="[tableCreateAccessObj, tableUpdateAccessObj]">
                                <mat-icon class="material-icons-outlined" >add</mat-icon>
                                {{ 'AddAPolicy' | translate: {Default: "Add A Policy"} }}
                            </button>
        
                            <div class="coverages">
                                <p class="no-data" *ngIf="timeOffLeaveTypes.value.length === 0">{{ 'NoTimeOffPoliciesAssigned' | translate: {Default: "No time off policies assigned"} }}</p>
            
                                <ng-container *ngFor="let timeOffLeaveType of timeOffLeaveTypes.value" >
                                    <app-balance-control 
                                        *ngIf="timeOffLeaveType.timeOffPolicy !== null"
                                        [employeeId]="employeeId"
                                        [employeeTimeOffType]="timeOffLeaveType"
                                        [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
                                        (emitDeleted)="getTimeOffTypes()">
                                    </app-balance-control>
                                </ng-container>
                            </div>
                        </ng-template>
        
                        <ng-template [ngIf]="timeOffLeaveTypes.error">Error</ng-template>
                        <ng-template [ngIf]="timeOffLeaveTypes.loading">
                            <ngx-skeleton-loader
                                count="5"
                                [theme]="{ 
                                    'height.px': 50
                                }"
                            ></ngx-skeleton-loader>
                        </ng-template>
                    </div>
                </ng-template>
        </div>
        
        <app-employee-absences [employeeID]="employeeId"></app-employee-absences>

        <app-pending-time-off-requests [employeeID]="employeeId"></app-pending-time-off-requests>

        <app-employee-stat-holiday-group 
            *ngIf="!isLoadingPermissions"
            [employeeId]="employeeId" 
            [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
        ></app-employee-stat-holiday-group>
    </mat-card-content>
</mat-card>
